
import './App.css';

function App() {

function printTest() {
  if (window.android?.printText) {
    window.android.printText("Hello from UROVO");
    window.android.startPrint();
  } 
  else if (window.Device?.printText) {
    window.Device.printText("Hello from UROVO");
    window.Device.startPrint();
  }
  else if (window.urovo?.printText) {
    window.urovo.printText("Hello from UROVO");
    window.urovo.startPrint();
  }
  else {
    alert("No printer API available.");
    window.print();
  }
}
  return (
    <div className="App">
     <button onClick={() => printTest()}> print</button>
    </div>
  );
}

export default App;
